module.exports = __webpack_public_path__ + "static/media/EmptyState.58e2fbab.png";